import React, { useEffect, useContext, useState } from "react";
import FormLayout from "../components/layout/FormLayout";
import { Link, useLocation, useNavigate } from "react-router-dom";
import findBrand from "../components/findBrand";
import { getsites, getMainDomainNew, loadBrands } from "../components/findBrand";
import * as FaIcons from "react-icons/fa";
import { brandDomains, fetchBrands } from "../components/brand";
import Flexhighlogo from "../img/Flexhighlogo.png";
import stanzalogo from "../img/stanzalogo.png";
import elev8logo from "../img/elev8logo.png";
import { Helmet } from "react-helmet-async";
import holstonlogo from "../img/holstonlogo.png";
import InterestContext from "../context/interest/interestContext";
import l4lFav from "../img/L4L-favicon.ico";
import llacFav from "../img/LLAC-favicon.ico";
import InterestForm from "../components/InterestForm/InterestForm";
import l4lLogo from "../img/l4l.png";
import pbialogo from "../img/PBIA.png";
import queryString from "query-string";
import LoadingSpinner from "../components/utilities/LoadingSpinner";


const EnrollmentInterestPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const interestContext = useContext(InterestContext);
  const {
    onFormDataChange,
    formData,
    setCampaignType,
    resetInterestForm
    // formData: { previouslyEnrolled, brandIcon },
  } = interestContext;

  const { getSiteprogram, charterPreSelected, Siteprogram } = interestContext;

  // Add state to store site ID
  const [siteId, setSiteId] = useState(null);
  const [isValidSite, setIsValidSite] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [mainDomain, setMainDomain] = useState(null);
  const [brandName, setBrandName] = useState(null);

  formData.learningCenterCharter = Siteprogram.charter && Siteprogram.charter.name;
  formData.learningCenterName = Siteprogram.name;

  // Move these declarations outside of conditional blocks
  const llac = brandDomains?.brand_llac?.name;
  const learn4life = brandDomains?.brand_learn4life?.name;
  const elev8schools = brandDomains?.brand_elev8?.name;
  const holstonacademy = brandDomains?.brand_holston?.name;
  const pbiacademy = brandDomains?.brand_pbia?.name;
  const flexhigh = brandDomains?.brand_flexhigh?.name;
  const stanza = brandDomains?.brand_stanza?.name;

  // Fallback logo mapping
  const fallbackLogos = {
    llac: llacFav,
    learn4life: l4lLogo,
    elev8schools: elev8logo,
    holstonacademy: holstonlogo,
    pbiacademy: pbialogo,
    flexhigh: Flexhighlogo,
    stanza: stanzalogo,
  };

  // Move function outside of conditional blocks
  const getBrandPhoto = () => {
    if (!brandDomains) return fallbackLogos[mainDomain] || l4lLogo;

    const brand = mainDomain;
  //  console.log("Brand Name:", brand);

    // Get brand photo based on brand name
    switch (brand) {
      case "llac":
        return brandDomains.brand_llac?.brandPhoto || fallbackLogos.llac;
      case "learn4life":
        return brandDomains.brand_learn4life?.brandPhoto || fallbackLogos.learn4life;
      case "elev8schools":
        return brandDomains.brand_elev8?.brandPhoto || fallbackLogos.elev8schools;
      case "holstonacademy":
        return brandDomains.brand_holston?.brandPhoto || fallbackLogos.holstonacademy;
      case "pbiacademy":
        return brandDomains.brand_pbia?.brandPhoto || fallbackLogos.pbiacademy;
      case "flexhigh":
        return brandDomains.brand_flexhigh?.brandPhoto || fallbackLogos.flexhigh;
      case "stanza":
        return brandDomains.brand_stanza?.brandPhoto || fallbackLogos.stanza;
      default:
        return brandDomains.brand_learn4life?.brandPhoto || fallbackLogos.learn4life;
    }
  };

  // Fix the brandPhoto logic
  const getBrandPhotoForSite = () => {
    if (siteId && siteId !== "") {
      // When we have a site ID, get photo from Siteprogram
      const siteBrandPhoto = Siteprogram?.charter?.brand?.brandPhoto;
      if (siteBrandPhoto) {
       // console.log("Site brandPhoto:", siteBrandPhoto);
        return siteBrandPhoto;
      }
    }
    
    // When no site ID or site brand photo not available, use brand-based photo
    return getBrandPhoto();
  };

  const brandPhoto = getBrandPhotoForSite();

  useEffect(() => {
    const loadBrandsAndSetDomain = async () => {
      try {
        // Ensure brands are loaded
        await loadBrands();

        // Get the main domain after brands are loaded
        const domain = getMainDomainNew();
        setMainDomain(domain);

        // Get the brand name
        const brand = getsites();
        setBrandName(brand);

        //  console.log("Main Domain:", domain);
        //console.log("Brand Name:", brand);
      } catch (error) {
        console.error("Error loading brands:", error);
        // Set fallback values
        setMainDomain(false);
        setBrandName(false);
      }
    };

    loadBrandsAndSetDomain();
  }, []);

  useEffect(() => {
    resetInterestForm();
    var query = queryString.parse(location.search);
    if (query.site) {
      setSiteId(query.site);
      getSiteprogram(query.site);
      //  console.log("site",query.site)
    } else {
      const site = "";
      setSiteId(site);
      setIsValidSite(true);
      setIsLoading(false);
      //console.log("site", site);
      navigate("/interest");
    }
    if (query.charter) {
      charterPreSelected(query.charter);
    }
    if (query.campaign) {
      setCampaignType(query.campaign);
    }
  }, []);

  useEffect(() => {
    //console.log("Siteprogram updated:", Siteprogram);

    if (siteId && siteId !== "") {
      // Give some time for the site data to load
      const timeoutId = setTimeout(() => {
        // Check if we have valid site data
        if (Siteprogram && (Siteprogram.name || Siteprogram._id || Siteprogram.id)) {
          console.log("Valid site data found");
          setIsValidSite(true);
          setIsLoading(false);
        } else {
          console.log("No valid site data found");
          setIsValidSite(false);
          setIsLoading(false);
        }
      }, 1500); // Wait 1.5 seconds for data to load

      return () => clearTimeout(timeoutId);
    } else if (siteId === "") {
      // Empty site is considered valid
      setIsValidSite(true);
      setIsLoading(false);
    }
  }, [Siteprogram, siteId]);

  //Import iframe functionality for website integration
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/@iframe-resizer/child@5.4.7";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Show loading state while brands are loading
  if (isLoading || brandName === null) {
    return (
      <FormLayout>
        <div style={{ backgroundColor: brandName === "learn4life" ? "#F7F3EC" : "#ffffff", padding: "2rem" }}>
          <div className="text-center">
            <p style={{ fontSize: "18px" }}><LoadingSpinner /></p>
          </div>
        </div>
      </FormLayout>
    );
  }

  // Show invalid site message
  if (!isValidSite && siteId && siteId !== "") {
    return (
      <FormLayout>
        <div style={{ backgroundColor: "#ffffff", padding: "2rem" }}>
          <div className="text-center">
            <h2 style={{ color: "#d32f2f", marginBottom: "1rem" }}>Invalid Site ID</h2>
            <p style={{ fontSize: "18px", marginBottom: "2rem" }}>
              The site ID "{siteId}" is not valid. Please check the URL and try again.
            </p>
          </div>
        </div>
      </FormLayout>
    );
  }

  return (
    <FormLayout>
      <div style={{ backgroundColor: brandName === "learn4life" ? "#F7F3EC" : "#ffffff" }}>
        {siteId !== "default" && brandName !== "learn4life" && (
          <div className="brand-header"  >
            <div className="text-center " style={{ marginTop: "10px" }}>
              <Link to="/">
                <img
                  src={brandPhoto}
                  alt=""
                  className="branding-logo"
                  height={"69px"}
                />
              </Link>
            </div>
          </div>
        )}

        {/* UPDATED CONDITIONAL HEADER LOGIC */}
        {brandName === "learn4life" ? (
          <></>
        ) : brandName !== "learn4life" && siteId === "" ? (
          <p className="text-center" style={{ fontSize: "20px", padding: "0em 2em" }}>
            We're excited to welcome you and support you on a journey filled with growth, discovery, and meaningful experiences.
            By expressing your interest, you're taking the first step toward an enriching educational path. We look forward to
            learning more about you and helping you achieve your academic and personal goals.
          </p>
        ) : (
          <p className="text-center" style={{ fontSize: "20px", padding: "0em 2em" }}>
            Thank you for your Interest to be a part of {formData.learningCenterCharter}-
            {formData.learningCenterName}. We are looking forward to welcoming you to our
            educational community! Your decision to join us marks the beginning of an exciting
            journey filled with growth, discovery, and new experiences. We look forward to supporting
            you as you pursue your academic and personal goals.
          </p>
        )}

        <InterestForm />
      </div>
    </FormLayout>
  );
};

export default EnrollmentInterestPage;